import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LoaderModule } from '@x/common/loader';
import { MediaModule } from '@x/common/media';
import { MediaThumbnailComponent } from '@x/common/media-thumbnail/media-thumbnail.component';
import { ProductMediaComponent } from './product-media.component';

@NgModule({
  declarations: [ProductMediaComponent],
  imports: [CommonModule, MediaModule, LoaderModule, MediaThumbnailComponent],
  exports: [ProductMediaComponent],
})
export class ProductMediaModule {}
